import React, { useState } from 'react';
import { Button } from '../components/Button';
import { CheckIcon, ArrowRightIcon, CalendarIcon } from 'lucide-react';
import { WaitlistModal } from '../components/WaitlistModal';
export function Construction() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans flex flex-col" data-id="element-1440">
      {/* Animated background elements */}
      <div className="fixed inset-0 overflow-hidden z-0" data-id="element-1441">
        <div className="absolute top-0 left-0 w-full h-full opacity-10" data-id="element-1442">
          {/* Circuit lines animation */}
          <div className="absolute top-1/4 left-0 w-full h-px bg-[#C8F169] animate-pulse" data-id="element-1443"></div>
          <div className="absolute top-2/4 left-0 w-full h-px bg-[#C8F169] animate-pulse delay-300" data-id="element-1444"></div>
          <div className="absolute top-3/4 left-0 w-full h-px bg-[#C8F169] animate-pulse delay-700" data-id="element-1445"></div>
          <div className="absolute top-0 left-1/4 w-px h-full bg-[#C8F169] animate-pulse delay-150" data-id="element-1446"></div>
          <div className="absolute top-0 left-2/4 w-px h-full bg-[#C8F169] animate-pulse delay-500" data-id="element-1447"></div>
          <div className="absolute top-0 left-3/4 w-px h-full bg-[#C8F169] animate-pulse delay-900" data-id="element-1448"></div>
          {/* Glowing orbs */}
          <div className="absolute top-1/4 left-1/4 w-4 h-4 rounded-full bg-[#C8F169] filter blur-sm animate-pulse" data-id="element-1449"></div>
          <div className="absolute top-2/4 left-2/4 w-4 h-4 rounded-full bg-[#C8F169] filter blur-sm animate-pulse delay-300" data-id="element-1450"></div>
          <div className="absolute top-3/4 left-3/4 w-4 h-4 rounded-full bg-[#C8F169] filter blur-sm animate-pulse delay-700" data-id="element-1451"></div>
        </div>
      </div>
      <main className="flex-grow flex items-center justify-center px-4 py-12 relative z-10" data-id="element-1452">
        <div className="max-w-3xl w-full mx-auto flex flex-col items-center" data-id="element-1453">
          {/* Main image */}
          <div className="w-full max-w-xl mb-8 relative" data-id="element-1454">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/imEfYrnKTcjaQadT1rj8bD/ChatGPT_Image_Aug_25%2C_2025%2C_05_48_17_PM.png" alt="Prepz.io Under Construction" className="w-full h-auto" data-id="element-1455" />
            <div className="absolute -inset-1 bg-[#C8F169] opacity-20 blur-xl rounded-full animate-pulse" data-id="element-1456"></div>
          </div>
          {/* Content */}
          <div className="text-center mb-12" data-id="element-1457">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1458">
              We're Building Something{' '}
              <span className="text-[#C8F169]" data-id="element-1459">Extraordinary</span>
            </h2>
            <p className="text-xl md:text-2xl text-[#F5F7FA] text-opacity-80 max-w-2xl mx-auto" data-id="element-1460">
              Prepz.io is coming soon with AI-powered meeting intelligence that
              will transform how you approach every conversation.
            </p>
          </div>
          {/* Waitlist CTA */}
          <div className="w-full max-w-md bg-[#1A2331] p-8 rounded-xl border border-[#F5F7FA] border-opacity-10 shadow-lg relative" data-id="element-1461">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-[#C8F169] to-[#3B82F6] opacity-20 blur rounded-xl" data-id="element-1462"></div>
            <div className="relative" data-id="element-1463">
              <div className="text-center py-4" data-id="element-1464">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#C8F169] bg-opacity-20 rounded-full mb-6" data-id="element-1465">
                  <CalendarIcon className="h-8 w-8 text-[#C8F169]" data-id="element-1466" />
                </div>
                <h3 className="text-xl font-semibold mb-4" data-id="element-1467">
                  Experience AI-Powered Meeting Briefs
                </h3>
                <p className="text-[#F5F7FA] text-opacity-70 mb-6" data-id="element-1468">
                  See a preview of our comprehensive meeting briefs and join our
                  waitlist to be the first to know when we launch.
                </p>
                <button onClick={() => setIsModalOpen(true)} className="w-full bg-[#C8F169] hover:bg-opacity-90 text-[#1E2A38] font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center" data-id="element-1469">
                  <ArrowRightIcon className="h-5 w-5 mr-2" data-id="element-1470" />
                  Preview & Join Waitlist
                </button>
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className="mt-16 text-center text-sm text-[#F5F7FA] text-opacity-50" data-id="element-1471">
            <p data-id="element-1472">© 2023 Prepz.io. All rights reserved.</p>
          </div>
        </div>
      </main>
      <WaitlistModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-1473" />
    </div>;
}